import Glide from "@glidejs/glide";

export default class TooltipSlider {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.tooltip-slider'), el => {
			new TooltipSlider(el);
		});
	}

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.slides = this.element.querySelectorAll('.glide__slide');
		this.slidesCount = this.slides.length;

		// in the Neos backend the element information is rendered in a appended script tag
		// since this script is executed after it's evaluation, we can safely remove it
		// to make the slider work properly
		const isNeosBackend = document.body.classList.contains('neos-backend');
		if (isNeosBackend) {
			Array.from(document.querySelectorAll('script[data-neos-nodedata]')).forEach((script) => script.remove())
		}

		const options = {
			peek: {before: 0, after: 0},
			gap: 0,
			arrows: false,
			rewind: false,
			type: 'slider',
			startAt: 0,
			focusAt: 0,
			perView: 1,
			bound: true,
			autoplay: false,
		};

		let ArrowDisable = function (Glide, Components) {
			return {
				mount() {
					// Only in effect when rewinding is disabled
					if (Glide.settings.rewind) {
						return
					}

					if (Glide.selector.parentElement.parentElement.classList.contains('category-slider')) return;

					Glide.on(['mount.after', 'run', 'move'], () => {
						// Filter out arrows_control
						for (let controlItem of Components.Controls.items) {
							if (controlItem.className !== 'glide__arrows') {
								continue
							}

							// Set left arrow state
							let left = controlItem.querySelector('.glide__arrow--left');
							if (left) {
								if (Glide.index === 0) {
									left.setAttribute('disabled', '') // Disable on first slide
								} else {
									left.removeAttribute('disabled') // Enable on other slides
								}
							}

							// Set right arrow state
							let right = controlItem.querySelector('.glide__arrow--right')
							if (right) {
								if (Glide.index >= Components.Sizes.length - Glide.settings.perView) {
									right.setAttribute('disabled', '') // Disable on last slide
								} else {
									right.removeAttribute('disabled') // Disable on other slides
								}
							}
						}
					})
				}
			}
		};

		this.slider = new Glide(this.element, options);

		this.slider.on('run.before', () => {
			let tooltipsWrapper = this.element.querySelector('.glide__slide--active .tooltip-slider-item__tooltip-wrapper');
			if (!tooltipsWrapper) return;

			let lottieAnimations = this.element.querySelectorAll('.tooltip-slider-item__lottie');
			if (lottieAnimations) {
				tooltipsWrapper.classList.remove('tooltip-slider-item__tooltip-wrapper--active');
			}
		});

		this.slider.on('run.after', () => {
			let tooltipsWrapper = this.element.querySelector('.glide__slide--active .tooltip-slider-item__tooltip-wrapper');
			let lottieAnimations = this.element.querySelectorAll('.tooltip-slider-item__lottie, .tooltip-slider-item__lottie-loop');
			if (lottieAnimations.length) {
				tooltipsWrapper.classList.add('tooltip-slider-item__tooltip-wrapper--active');
			}
			this.playLottieAnimation();
		});

		this.slider.on('build.after', () => {
			console.log('animate on slider build');
			window.addEventListener('scroll', () => {
				if (this.isInViewport() && !this.element.classList.contains('tooltip-slider--animated')) {
					this.element.classList.add('tooltip-slider--animated')
					this.playLottieAnimation();
				}
			});

			setTimeout(() => this.preloadAssets(), 500);
		});

		this.slider.mount({ArrowDisable});
	}

	preloadAssets() {
		const imageUris = [
			'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide1/images/img_12.jpg',
			'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide1/images/img_0.png',
			'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide1/images/img_1.png',
			'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide1/images/img_2.png',
			'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide1/images/img_3.png',
			'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide1/images/img_4.png',
			'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide1/images/img_5.png',
			'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide1/images/img_6.png',
			'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide1/images/img_7.png',
			'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide1/images/img_8.png',
			'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide1/images/img_9.png',
			'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide1/images/img_10.png',
			'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide1/images/img_11.png',
		];
		imageUris.forEach(imageUri => {
			(new Image()).src = imageUri;
		});

		setTimeout(() => {
			const imageUris = [
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/empty-background.jpg',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide2/images/img_0.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide2/images/img_1.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide2/images/img_2.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide2/images/img_3.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide2/images/img_4.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide2/images/img_5-jochen-borenich.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide2/images/img_6.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide2/images/img_7.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide2/images/img_8.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide2/images/img_9.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide2/images/img_10.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide2/images/img_11.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide2/images/img_12.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide2/images/img_13.png',

				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide3/images/img_0.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide3/images/img_1.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide3/images/img_2.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide3/images/img_3.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide3/images/img_4.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide3/images/img_5.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide3/images/img_6.jpg',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide3/images/img_7.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide3/images/img_8.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide3/images/img_9.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide3/images/img_10.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide3/images/img_11.png',

				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide4/images/img_0.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide4/images/img_1.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide4/images/img_2.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide4/images/img_3.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide4/images/img_4.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide4/images/img_5.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide4/images/img_6.png',
				'/_Resources/Static/Packages/CodeQ.Site/LottieAnimation/SurplusValues/Slide4/images/img_7.png',
			];
			imageUris.forEach(imageUri => {
				(new Image()).src = imageUri;
			});
		}, 2000);
	}

	onLottieAnimationFinished() {
		let tooltipsWrapper = this.element.querySelector('.glide__slide--active .tooltip-slider-item__tooltip-wrapper');
		if (!tooltipsWrapper) return;

		tooltipsWrapper.classList.add('tooltip-slider-item__tooltip-wrapper--active');
	}

	playLottieAnimation() {
		let slide = this.element.querySelector('.glide__slide--active');
		if (!slide) {
			console.error('No active slide', this.element);
			return;
		}

		// stop and reset old animations
		Array.from(this.element.querySelectorAll('.tooltip-slider-item__lottie, .tooltip-slider-item__lottie-loop')).forEach(el => {
			if (typeof el.stop === 'function') {
				el.stop();
				el.seek(0);
			}
		});

		this.playOnLottiePlayerLoaded(
			slide.querySelector('.tooltip-slider-item__lottie'),
			slide.querySelector('.tooltip-slider-item__lottie-loop')
		);
	}

	playOnLottiePlayerLoaded = (el, loopEl) => {
		if (!el) {
			return;
		}
		if (typeof el.getLottie !== 'function') {
			setTimeout(() => this.playOnLottiePlayerLoaded(el, loopEl), 300);
			return;
		}

		console.info('Play lottie animation...');
		if (loopEl) loopEl.classList.remove('tooltip-slider-item__lottie-loop--visible');
		if (loopEl && !loopEl.getLottie()) loopEl.load(loopEl.getAttribute('data-src'));
		el.seek(0);


		setTimeout(() => {
			// animation looks better, when it starts after the slide animation is finished
			el.play();

			// after the show animation is finished, run the endless loop
			el.addEventListener('complete', () => {
				this.onLottieAnimationFinished();

				if (loopEl) {
					console.info('Play lottie loop animation...');
					loopEl.classList.add('tooltip-slider-item__lottie-loop--visible');
					loopEl.seek(0);
					loopEl.play();
				}
			}, {
				once: true
			});
		}, 500);
	};

	isInViewport() {
		let el = this.element.closest('section');
		let top = el.offsetTop;
		let left = el.offsetLeft;
		let width = el.offsetWidth;
		let height = el.offsetHeight;

		while (el.offsetParent) {
			el = el.offsetParent;
			top += el.offsetTop;
			left += el.offsetLeft;
		}

		return (
			top < (window.pageYOffset + window.innerHeight - height / 2) &&
			left < (window.pageXOffset + window.innerWidth) &&
			(top + height / 2) > window.pageYOffset &&
			(left + width) > window.pageXOffset
		);
	}
}
